<template>
    <section class="flex flex-col">
        <div id="portal-content-header-prepend" />
        <div class="md:flex">
            <div class="flex grow justify-between">
                <div class="flex items-center mb-6 min-w-0 gap-3">
                    <div id="portal-content-header" class="contents">
                        <h1
                            class="content-header-fallback m-0 text-2xl font-semibold text-grey-650 lg:ml-4"
                            v-text="pageTitle"
                        />
                    </div>
                    <div id="portal-content-header-left" class="flex items-center gap-3" />
                </div>
                <div id="portal-content-header-right" class="mb-6" />
            </div>
            <div id="portal-content-header-append" class="mb-6" />
        </div>
    </section>
</template>

<script setup>
    import { storeToRefs } from 'pinia';
    import { useGlobalStore } from '../store/store.ts';

    const globalStore = useGlobalStore();
    const { pageTitle } = storeToRefs(globalStore);
</script>

<style scoped>
    #portal-content-header > .content-header-fallback:not(:only-child) {
        display: none;
    }
</style>
